angular.module('zc')
  .component('zcIwUtmMediumRate', {
    templateUrl: '/templates/projects.iw/iw_utm_medium_rate.html',
    bindings: {
      project: '<',
      filters: '<'
    },
    controller: zcIwUtmMediumRateController
  });

zcIwUtmMediumRateController.$inject = ['$scope', '$translate', 'InterestWidgetStats', 'ChartV2', 'pieChartV2Config', 'lib'];
function zcIwUtmMediumRateController($scope, $translate, InterestWidgetStats, ChartV2, pieChartV2Config, lib) {
  const vm = this;

  const chart = new ChartV2(pieChartV2Config);
  vm.chartConfig = chart.getConfig();

  vm.$onInit = () => {
    updateData();
    $scope.$on('filtersUpdated', updateData);
  };

  function updateData() {
    InterestWidgetStats.findByFilters(vm.project.apikey, vm.filters)
      .then(stats => {
        vm.utmMediumData = getUtmMediumData(stats);
        chart.resetSeries();
        chart.addSeries({ data: getChartData(vm.utmMediumData) });
      });
  }

  function getUtmMediumData(stats) {
    let data = [];
    let otherCount = 0;
    let otherRate = 0;
    if(stats.length) {
      const total = InterestWidgetStats.transform(lib.sumCountMap(stats));
      data = _.chain(total.iw_use.utm_medium_count_map)
        .keys()
        .map(key => {
          return {
            key: _.truncate(key, { length: 14, omission: '…' }),
            count: total.iw_use.utm_medium_count_map[key],
            rate: total.iw_use.utm_medium_rate_map[key],
          };
        })
        .sortBy('rate')
        .reverse()
        .value();
      otherCount = total.iw_use.session_count - _.sumBy(data, 'count');
      otherRate = (total.iw_use.session_count !== 0) ? otherCount / total.iw_use.session_count * 100 : 0;
    }
    data.push({ key: $translate.instant('projectsIw.utmMediumRate.other'), count: otherCount, rate: otherRate });
    return data;
  }

  function getChartData(data) {
    if(_.sumBy(data, 'count') >= 1) {
      return data.map(datum => [datum.key, datum.rate]);
    }
    return [];
  }
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.iw/iw_utm_medium_rate.js